module.exports = __webpack_public_path__ + "assets/img/description-2-756e6baa.png";